import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {User} from '../model/user';
import {SharedPreference} from '../shared-preference/shared-perference';
import {Role} from '../model/role';
import {ApiService} from '../services/http-service/api.service';
import {LoggUtilInfo} from '../utils/loggUtil';

@Injectable({
  providedIn: 'root'
})
export class NotificationGuard implements CanActivate {
  constructor(private apiService: ApiService) {
  }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    const user: User = SharedPreference.getUser();

    if (Role.hasVersitaAdmin(user) || Role.hasAdminRole(user))  {
      if (Role.hasVersitaAdmin(user)) {
        return !user.isRequireChangePassword
      } else {
        const whiteLabelPlatform = await this.getPlatforms();
        return whiteLabelPlatform.length > 0 && !user.isRequireChangePassword;
      }
    } else {
      return false;
    }

  }

  async getPlatforms() {
    try {
      const promise: any = await this.apiService.requestPlatforms(null, SharedPreference.getStoreId()).toPromise();
      let platformWhiteLabel = [];
      platformWhiteLabel.push(promise['result']);
      return platformWhiteLabel;
    } catch (e) {
      return [];
      LoggUtilInfo.loggingError("component notification gaurd get platform",e)
    }
  }
}
